import { Card } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import iconSet from '../../assets/selection.json';
import IcomoonReact from 'icomoon-react';

import * as colors from '../../common/styles/colors';
import { Loading } from '../../common/components';

type FAQAccordionItemProps = {
  item: Api.IFAQItem;
  containsImage: boolean;
  imageSrc: any;
  isOpen: boolean;
  toggleItem: Function;
};

const defaultProps = {};

export const FAQAccordionItem = (props: FAQAccordionItemProps) => {
  const { item, containsImage, imageSrc, isOpen, toggleItem } = props;

  return (
    <>
      <Card key={item?.id}>
        <Card.Header
          className='d-flex align-items-center'
          style={{ cursor: 'pointer' }}
          onClick={() => toggleItem(item?.id)}
          aria-expanded={isOpen}
        >
          <div className='question'>
            <ReactMarkdown>{item.question}</ReactMarkdown>
          </div>

          <div className='ml-auto'>
            <IcomoonReact
              iconSet={iconSet}
              color={colors.darkGrey}
              size={15}
              icon={`${isOpen ? 'chevron-up' : 'chevron-down'}`}
            />
          </div>
        </Card.Header>

        <div className={`collapse ${isOpen ? 'show' : ''}`}>
          <Card.Body>
            <div className='pt-2'>
              <ReactMarkdown>{item.answer}</ReactMarkdown>
            </div>
            <div className='pt-2'>
              <ReactMarkdown>{item.supportingLink}</ReactMarkdown>
            </div>
            {containsImage && (
              <div>
                {imageSrc ? (
                  <img src={imageSrc} alt='' style={{ width: '100%', objectFit: 'cover' }} loading='lazy' />
                ) : (
                  <Loading />
                )}
              </div>
            )}
            <div className='pt-2'>
              <ReactMarkdown>{item.imageSupportingText}</ReactMarkdown>
            </div>
          </Card.Body>
        </div>
      </Card>
    </>
  );
};

FAQAccordionItem.defaultProps = defaultProps;
